<template>
    <div id="app">
      <div class="banner">
        <div class="bannerleft">
          <img src="../../public/images/logo.png" />
          <!-- <h1>Yao28.Com</h1> -->
        </div>
      </div>
    
      <div class="container container-h">
       
        <div class="tabView" >
          <table class="tabtitle">
            <tr>
              <td :class="tabIndex == 0 ? 'active' : ''" @click="goToTargetPage(0,0)">加拿大28</td>
              <td :class="tabIndex == 1 ? 'active' : ''" @click="goToTargetPage(1,0)">台湾28</td>
              <td :class="tabIndex == 2 ? 'active' : ''" @click="goToTargetPage(2,0)">北京28</td>
              <td :class="tabIndex == 3 ? 'active' : ''" @click="goToTargetPage(3,0)">香港28</td>
            </tr>
            <tr>
              <td @click="goToTargetPage(0,0)">单双</td>
              <td @click="goToTargetPage(0,1)">大小</td>
              <td @click="goToTargetPage(0,2)">组合</td>
              <td @click="goToTargetPage(0,3)">杀组合</td>
            </tr>
          </table>
          <!-- <div :class="tabIndex == 0 ? 'active' : ''" @click="goToTargetPage(0,0)">
            <span>加拿大28</span>
          </div>
          <div :class="tabIndex == 1 ? 'active' : ''" @click="goToTargetPage(1,0)">
            <span>台湾28</span>
          </div>
          <div :class="tabIndex == 2 ? 'active' : ''" @click="goToTargetPage(2,0)">
            <span>北京28</span>
          </div>
          <div :class="tabIndex == 3 ? 'active' : ''" @click="goToTargetPage(3,0)">
            <span>香港28</span>
          </div>
          <div  @click="goToTargetPage(0,0)">
            <span>单双</span>
          </div>
          <div  @click="goToTargetPage(0,1)">
            <span>大小</span>
          </div>
          <div  @click="goToTargetPage(0,2)">
            <span>组合</span>
          </div>
          <div  @click="goToTargetPage(0,3)">
            <span>杀组合</span>
          </div> -->
        </div>
  
        <div class="nlotIContent">
          <div class="outer" >
            <div class="canada cent">
              <div class="within">
                  <img src="../assets/images/njnd28.png" @mouseover="zoomIn" @mouseleave="zoomOut" @click="goToTargetPage(0,0)" />
                  <div class="dont">
                    <div class="top">
                      <span class="lef" @click="goToTargetPage(0,0)">加拿大28</span>
                      <i>{{ jndlastNumInfo.openNum }}</i>期
                      <span class="rig">每天393期，00:03起每3分钟30秒一期，不定期开奖</span>
                    </div>
                    <div class="bot">
                              <div class="lef">
                                <div class="cyanBlue  lot-result" v-show="!jndshowWait">{{ jndqueryOpenNum.result[0] }}</div>
                                <div class="cyanBlue  lot-result" v-show="jndshowWait">?</div>
                                <div class="ml5"><span>+</span></div>
                                <div class="cyanBlue  lot-result ml5" v-show="!jndshowWait">{{ jndqueryOpenNum.result[1] }}</div>
                                <div class="cyanBlue  lot-result ml5" v-show="jndshowWait">?</div>
                                <div class="ml5"><span>+</span></div>
                                <div class="cyanBlue  lot-result ml5" v-show="!jndshowWait">{{ jndqueryOpenNum.result[2] }}</div>
                                <div class="cyanBlue  lot-result ml5" v-show="jndshowWait">?</div>
                                <div class="ml5"><span>=</span></div>
                                <div v-show="!jndshowWait" :class="getColor(getSum(this.jndqueryOpenNum))==1?'skyBlue1':getColor(getSum(this.jndqueryOpenNum))==2?'skyBlue2':getColor(getSum(this.jndqueryOpenNum))==3?'skyBlue3':''" class="skyBlue lot-result ml5">{{ getSum(this.jndqueryOpenNum).toString().padStart(2, '0') }}</div>
                                <div v-show="jndshowWait" :class="getColor(getSum(this.jndqueryOpenNum))==1?'skyBlue1':getColor(getSum(this.jndqueryOpenNum))==2?'skyBlue2':getColor(getSum(this.jndqueryOpenNum))==3?'skyBlue3':''" class="skyBlue lot-result ml5">??</div>
                              </div>
                              <div class="section" v-if="jndshowWait">正在开奖...</div>
                              <div class="rig" v-if="!jndshowWait">
                                <span>倒计时:</span>
                                <b>{{ jndnextNumTime[0] }}</b>
                                <span>分</span>
                                <b>{{ jndnextNumTime[1] }}</b>
                                <span>秒</span>
                              </div>
                    </div>
                  </div>
              </div>
              <table>
                  <tr class="top">
                    <td style="width: 20%;">和值</td>
                    <td style="width: 60%;">形态</td>
                    <td style="width: 20%;">顺子/对子/豹子</td>
                  </tr>
                  <tr>
                    <td>{{ getSum(this.jndqueryOpenNum).toString().padStart(2, '0') }}</td>
                    <td class="le"> 
                      <div> 
                        <template v-if="isBigNum(getSum(this.jndqueryOpenNum))">大</template>
                        <template v-else>小</template>
                      </div>
                      <div>
                        <template v-if="isOddNumber(getSum(this.jndqueryOpenNum))">单</template>
                        <template v-else>双</template>
                      </div>
                      <div :class="getColor(getSum(this.jndqueryOpenNum))==1?'greenc':getColor(getSum(this.jndqueryOpenNum))==2?'redc':getColor(getSum(this.jndqueryOpenNum))==3?'bluec':''">
                        {{ getColor(getSum(this.jndqueryOpenNum))==1?'绿波':getColor(getSum(this.jndqueryOpenNum))==2?'红波':getColor(getSum(this.jndqueryOpenNum))==3?'蓝波':'' }}
                      </div>
                    </td>
                    <td class="ri">
                      {{ describeTools(this.jndqueryOpenNum) }}
                    </td>
                  </tr>
              </table>
               <!-- <div class="botto"></div> -->
            </div>
          </div>
          <div class="outer" >
            <div class="taiwan cent">
              <div class="within">
                <img src="../assets/images/ntw28.png" @mouseover="zoomIn" @mouseleave="zoomOut" @click="goToTargetPage(1,0)"/>
                  <div class="dont">
                    <div class="top">
                      <span class="lef" @click="goToTargetPage(1,0)">台湾28</span>
                      <i>{{ twlastNumInfo.openNum }}</i>期
                      <span class="rig">每天203期，07:05起每5分钟开奖一期</span>
                    </div>
                    <div class="bot">
                              <div class="lef">
                                <div class="cyanBlue  lot-result" v-show="!twshowWait">{{ twqueryOpenNum.result[0] }}</div>
                                <div class="cyanBlue  lot-result" v-show="twshowWait">?</div>
                                <div class="ml5"><span>+</span></div>
                                <div class="cyanBlue  lot-result ml5" v-show="!twshowWait">{{ twqueryOpenNum.result[1] }}</div>
                                <div class="cyanBlue  lot-result ml5" v-show="twshowWait">?</div>
                                <div class="ml5"><span>+</span></div>
                                <div class="cyanBlue  lot-result ml5" v-show="!twshowWait">{{ twqueryOpenNum.result[2] }}</div>
                                <div class="cyanBlue  lot-result ml5" v-show="twshowWait">?</div>
                                <div class="ml5"><span>=</span></div>
                                <div v-show="!twshowWait" :class="getColor(getSum(this.twqueryOpenNum))==1?'skyBlue1':getColor(getSum(this.twqueryOpenNum))==2?'skyBlue2':getColor(getSum(this.twqueryOpenNum))==3?'skyBlue3':''" class="skyBlue lot-result ml5">{{ getSum(this.twqueryOpenNum).toString().padStart(2, '0') }}</div>
                                <div v-show="twshowWait" :class="getColor(getSum(this.twqueryOpenNum))==1?'skyBlue1':getColor(getSum(this.twqueryOpenNum))==2?'skyBlue2':getColor(getSum(this.twqueryOpenNum))==3?'skyBlue3':''" class="skyBlue lot-result ml5">??</div>
                              </div>
                              <div class="section" v-if="twshowWait">正在开奖...</div>
                              <div class="rig" v-if="!twshowWait">
                                <span>倒计时:</span>
                                <b>{{ twnextNumTime[0] }}</b>
                                <span>分</span>
                                <b>{{ twnextNumTime[1] }}</b>
                                <span>秒</span>
                              </div>
                    </div>
                  </div>
              </div>
              <table>
                  <tr class="top">
                    <td style="width: 20%;">和值</td>
                    <td style="width: 60%;">形态</td>
                    <td style="width: 20%;">顺子/对子/豹子</td>
                  </tr>
                  <tr>
                    <td>{{ getSum(this.twqueryOpenNum).toString().padStart(2, '0') }}</td>
                    <td class="le"> 
                      <div> 
                        <template v-if="isBigNum(getSum(this.twqueryOpenNum))">大</template>
                        <template v-else>小</template>
                      </div>
                      <div>
                        <template v-if="isOddNumber(getSum(this.twqueryOpenNum))">单</template>
                        <template v-else>双</template>
                      </div>
                      <div :class="getColor(getSum(this.twqueryOpenNum))==1?'greenc':getColor(getSum(this.twqueryOpenNum))==2?'redc':getColor(getSum(this.twqueryOpenNum))==3?'bluec':''">
                        {{ getColor(getSum(this.twqueryOpenNum))==1?'绿波':getColor(getSum(this.twqueryOpenNum))==2?'红波':getColor(getSum(this.twqueryOpenNum))==3?'蓝波':'' }}
                      </div>
                    </td>
                    <td class="ri">
                      {{ describeTools(this.twqueryOpenNum) }}
                    </td>
                  </tr>
              </table>
              <!-- <div class="botto"></div> -->
            </div>
          </div>
          <div class="outer" >
            <div class="beijing cent">
              <div class="within">
                <img src="../assets/images/nbj28.png" @mouseover="zoomIn" @mouseleave="zoomOut" @click="goToTargetPage(2,0)"/>
                  <div class="dont">
                    <div class="top">
                      <span class="lef" @click="goToTargetPage(2,0)">北京28</span>
                      <i>{{ bjlastNumInfo.openNum }}</i>期
                      <span class="rig">每天393期，00:03起每3分钟一期，不定期开奖</span>
                    </div>
                    <div class="bot">
                              <div class="lef">
                                <div class="cyanBlue  lot-result" v-show="!bjshowWait">{{ bjqueryOpenNum.result[0] }}</div>
                                <div class="cyanBlue  lot-result" v-show="bjshowWait">?</div>
                                <div class="ml5"><span>+</span></div>
                                <div class="cyanBlue  lot-result ml5" v-show="!bjshowWait">{{ bjqueryOpenNum.result[1] }}</div>
                                <div class="cyanBlue  lot-result ml5" v-show="bjshowWait">?</div>
                                <div class="ml5"><span>+</span></div>
                                <div class="cyanBlue  lot-result ml5" v-show="!bjshowWait">{{ bjqueryOpenNum.result[2] }}</div>
                                <div class="cyanBlue  lot-result ml5" v-show="bjshowWait">?</div>
                                <div class="ml5"><span>=</span></div>
                                <div v-show="!bjshowWait" :class="getColor(getSum(this.bjqueryOpenNum))==1?'skyBlue1':getColor(getSum(this.bjqueryOpenNum))==2?'skyBlue2':getColor(getSum(this.bjqueryOpenNum))==3?'skyBlue3':''" class="skyBlue lot-result ml5">{{ getSum(this.bjqueryOpenNum).toString().padStart(2, '0') }}</div>
                                <div v-show="bjshowWait" :class="getColor(getSum(this.bjqueryOpenNum))==1?'skyBlue1':getColor(getSum(this.bjqueryOpenNum))==2?'skyBlue2':getColor(getSum(this.bjqueryOpenNum))==3?'skyBlue3':''" class="skyBlue lot-result ml5">??</div>
                              </div>
                              <div class="section" v-if="bjshowWait">正在开奖...</div>
                              <div class="rig" v-if="!bjshowWait">
                                <span>倒计时:</span>
                                <b>{{ bjnextNumTime[0] }}</b>
                                <span>分</span>
                                <b>{{ bjnextNumTime[1] }}</b>
                                <span>秒</span>
                              </div>
                    </div>
                  </div>
              </div>
              <table>
                  <tr class="top">
                    <td style="width: 20%;">和值</td>
                    <td style="width: 60%;">形态</td>
                    <td style="width: 20%;">顺子/对子/豹子</td>
                  </tr>
                  <tr>
                    <td>{{ getSum(this.bjqueryOpenNum).toString().padStart(2, '0') }}</td>
                    <td class="le"> 
                      <div> 
                        <template v-if="isBigNum(getSum(this.bjqueryOpenNum))">大</template>
                        <template v-else>小</template>
                      </div>
                      <div>
                        <template v-if="isOddNumber(getSum(this.bjqueryOpenNum))">单</template>
                        <template v-else>双</template>
                      </div>
                      <div :class="getColor(getSum(this.bjqueryOpenNum))==1?'greenc':getColor(getSum(this.bjqueryOpenNum))==2?'redc':getColor(getSum(this.bjqueryOpenNum))==3?'bluec':''">
                        {{ getColor(getSum(this.bjqueryOpenNum))==1?'绿波':getColor(getSum(this.bjqueryOpenNum))==2?'红波':getColor(getSum(this.bjqueryOpenNum))==3?'蓝波':'' }}
                      </div>
                    </td>
                    <td class="ri">
                      {{ describeTools(this.bjqueryOpenNum) }}
                    </td>
                  </tr>
              </table>
              <!-- <div class="botto"></div> -->
            </div>
          </div>
          <div class="outer" >
            <div class="hongkong cent">
              <div class="within">
                <img src="../assets/images/nxg28.png" @mouseover="zoomIn" @mouseleave="zoomOut" @click="goToTargetPage(3,0)"/>
                  <div class="dont">
                    <div class="top">
                      <span class="lef" @click="goToTargetPage(3,0)">香港28</span>
                      <i>{{ xglastNumInfo.openNum }}</i>期
                      <span class="rig">每天393期，00:03起每3分钟一期，不定期开奖</span>
                    </div>
                    <div class="bot">
                              <div class="lef">
                                <div class="cyanBlue  lot-result" v-show="!xgshowWait">{{ xgqueryOpenNum.result[0] }}</div>
                                <div class="cyanBlue  lot-result" v-show="xgshowWait">?</div>
                                <div class="ml5"><span>+</span></div>
                                <div class="cyanBlue  lot-result ml5" v-show="!xgshowWait">{{ xgqueryOpenNum.result[1] }}</div>
                                <div class="cyanBlue  lot-result ml5" v-show="xgshowWait">?</div>
                                <div class="ml5"><span>+</span></div>
                                <div class="cyanBlue  lot-result ml5" v-show="!xgshowWait">{{ xgqueryOpenNum.result[2] }}</div>
                                <div class="cyanBlue  lot-result ml5" v-show="xgshowWait">?</div>
                                <div class="ml5"><span>=</span></div>
                                <div v-show="!xgshowWait" :class="getColor(getSum(this.xgqueryOpenNum))==1?'skyBlue1':getColor(getSum(this.xgqueryOpenNum))==2?'skyBlue2':getColor(getSum(this.xgqueryOpenNum))==3?'skyBlue3':''" class="skyBlue lot-result ml5">{{ getSum(this.xgqueryOpenNum).toString().padStart(2, '0') }}</div>
                                <div v-show="xgshowWait" :class="getColor(getSum(this.xgqueryOpenNum))==1?'skyBlue1':getColor(getSum(this.xgqueryOpenNum))==2?'skyBlue2':getColor(getSum(this.xgqueryOpenNum))==3?'skyBlue3':''" class="skyBlue lot-result ml5">??</div>
                              </div>
                              <div class="section" v-if="xgshowWait">正在开奖...</div>
                              <div class="rig" v-if="!xgshowWait">
                                <span>倒计时:</span>
                                <b>{{ xgnextNumTime[0] }}</b>
                                <span>分</span>
                                <b>{{ xgnextNumTime[1] }}</b>
                                <span>秒</span>
                              </div>
                    </div>
                  </div>
              </div>
              <table>
                  <tr class="top">
                    <td style="width: 20%;">和值</td>
                    <td style="width: 60%;">形态</td>
                    <td style="width: 20%;">顺子/对子/豹子</td>
                  </tr>
                  <tr>
                    <td>{{ getSum(this.xgqueryOpenNum).toString().padStart(2, '0') }}</td>
                    <td class="le"> 
                      <div> 
                        <template v-if="isBigNum(getSum(this.xgqueryOpenNum))">大</template>
                        <template v-else>小</template>
                      </div>
                      <div>
                        <template v-if="isOddNumber(getSum(this.xgqueryOpenNum))">单</template>
                        <template v-else>双</template>
                      </div>
                      <div :class="getColor(getSum(this.xgqueryOpenNum))==1?'greenc':getColor(getSum(this.xgqueryOpenNum))==2?'redc':getColor(getSum(this.xgqueryOpenNum))==3?'bluec':''">
                        {{ getColor(getSum(this.xgqueryOpenNum))==1?'绿波':getColor(getSum(this.xgqueryOpenNum))==2?'红波':getColor(getSum(this.xgqueryOpenNum))==3?'蓝波':'' }}
                      </div>
                    </td>
                    <td class="ri">
                      {{ describeTools(this.xgqueryOpenNum) }}
                    </td>
                  </tr>
              </table>
              <!-- <div class="botto"></div> -->
            </div>
          </div>
  
        </div>
  
      </div>
  
    </div>
  </template>
  
  <script>
  // import homeTable from './components/homeTable.vue';
  
  export default {
    name: 'App',
    components: {
      // homeTable,
    },
    data() {
      return {
        jndtableData: [],
        twtableData: [],
        bjtableData: [],
        xgtableData: [],
        showTableIndex: 0,
        tabIndex: 8,
        listQuery: {
          pageLimit: 50,
          pageIndex: 1
        },
        jndlastNumInfo: {openNum: "",openTime: 0,stopBetTime: 0},
        twlastNumInfo:  {openNum: "",openTime: 0,stopBetTime: 0},
        bjlastNumInfo:  {openNum: "",openTime: 0,stopBetTime: 0},
        xglastNumInfo:  {openNum: "",openTime: 0,stopBetTime: 0},
        jndnextNumTime: ['--', '--'],
        twnextNumTime: ['--', '--'],
        bjnextNumTime: ['--', '--'],
        xgnextNumTime: ['--', '--'],
        jndshowWait: false,
        twshowWait: false,
        bjshowWait: false,
        xgshowWait: false,
        jndtimeHandle: null,
        twtimeHandle: null,
        bjtimeHandle: null,
        xgtimeHandle: null,
        jndqueryOpenNum: {openNum: "",result: ["--", '--', '--']},
        twqueryOpenNum: {openNum: "",result: ["--", '--', '--']},
        bjqueryOpenNum: {openNum: "",result: ["--", '--', '--']},
        xgqueryOpenNum: {openNum: "",result: ["--", '--', '--']},
        showResultModel: 0
      }
    },
    created() {
      this.getCanada28LastNumInfo()
      this.getTaiwan28LastNumInfo()
      this.getBeijing28LastNumInfo()
      this.getHongKong28LastNumInfo()
      this.jndtimeHandle = setInterval(this.jndcalcNextTime, 1000);
      this.twtimeHandle = setInterval(this.twcalcNextTime, 1000);
      this.bjtimeHandle = setInterval(this.bjcalcNextTime, 1000);
      this.xgtimeHandle = setInterval(this.xgcalcNextTime, 1000);
    },
    destroyed() {
      if (this.jndtimeHandle != null) {clearInterval(this.jndcalcNextTime);}
      if (this.twtimeHandle != null) {clearInterval(this.twcalcNextTime);}
      if (this.bjtimeHandle != null) {clearInterval(this.bjcalcNextTime);}
      if (this.xgtimeHandle != null) {clearInterval(this.xgcalcNextTime);}
    },
    methods: {
      toIndexTable(){
        this.$router.push('/');
      },
      goToTargetPage(tabIndex,showTableIndex) {
        let params={
          tabi: tabIndex,
          showti: showTableIndex
        }
        this.$router.push({name: 'homeTable',params});
      },
      zoomIn(event) {
        event.target.style.transform = 'scale(1.1)';
      },
      zoomOut(event) {
        event.target.style.transform = 'scale(1)';
      },
      calcResult(tableData) {
        tableData.forEach(item => {
          let sumResult = 0
          item.openTime = this.getdate(item.openTime)
          if (item.result == null || item.result.length == 0) {
            // console.log("item.result == null")
          } else {
            item.result.forEach(value => {
              sumResult += value
            })
            item.sumResult = sumResult
          }
        })
      },
  
      //台湾
      async getTaiwan28LastNumInfo() {
        let res = await this.$axios.post("https://apis.pcz28.com/api2/taiwan28/getLastNumInfo", {})
        this.twlastNumInfo = res.data
        this.queryTaiwan28Result()
      },
      async queryTaiwan28Result() {
            try {
              const response = await fetch("https://apis.pcz28.com/api2/taiwan28/getResultRecord2?pageLimit=50&pageIndex=1");
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              const data = await response.json();
              this.twtableData = data.data
              this.twqueryOpenNum = {
                openNum: "",
                result: ["--", '--', '--']
              }
              if (this.twtableData.length > 0) {
                if (this.showResultModel == 1) {
                  this.showResultModel = 0
                  this.$nextTick(() => {
                    this.showResultModel = 1
                    this.twqueryOpenNum = this.twtableData[1]
                  })
                } else {
                  this.twqueryOpenNum = this.twtableData[1]
                }
              }
              this.calcResult(this.twtableData);
            } catch (error) {
              console.error('Error fetching data:', error);
            }
      },
   
      //香港
      async getHongKong28LastNumInfo() {
        let res = await this.$axios.post("https://apis.hkpc28.com/api3/hkong28/getLastNumInfo", {})
        this.xglastNumInfo = res.data
        this.queryHongKong28Result()
      },
      async queryHongKong28Result() {
        let res = await this.$axios.post("https://apis.hkpc28.com/api3/hkong28/getResultRecord", this.listQuery)
        this.xgtableData = res.data
        this.xgqueryOpenNum = {
          openNum: "",
          result: ["--", '--', '--']
        }
        if (this.xgtableData.length > 0) {
          if (this.showResultModel == 1) {
            this.showResultModel = 0
            this.$nextTick(() => {
              this.showResultModel = 1
              this.xgqueryOpenNum = this.xgtableData[1]
            })
          } else {
            this.xgqueryOpenNum = this.xgtableData[1]
          }
        }
        this.calcResult(this.xgtableData);
      },
  
      //北京
      async getBeijing28LastNumInfo() {
        let res = await this.$axios.post("https://apis.hkpc28.com/api/australia28/getLastNumInfo", {})
        this.bjlastNumInfo = res.data
        this.queryBeijing28Result()
      },
      async queryBeijing28Result() {
        let res = await this.$axios.post("https://apis.hkpc28.com/api/australia28/getResultRecord", this.listQuery)
        this.bjtableData = res.data
        this.bjqueryOpenNum = {
          openNum: "",
          result: ["--", '--', '--']
        }
        if (this.bjtableData.length > 0) {
          if (this.showResultModel == 1) {
            this.showResultModel = 0
            this.$nextTick(() => {
              this.showResultModel = 1
              this.bjqueryOpenNum = this.bjtableData[1]
            })
          } else {
            this.bjqueryOpenNum = this.bjtableData[1]
          }
        }
        this.calcResult(this.bjtableData);
      },
  
      //加拿大
      async getCanada28LastNumInfo() {
        let res = await this.$axios.post("https://apis.pcz28.com/api/canada28/getLastNumInfo", {})
        this.jndlastNumInfo = res.data
        this.queryCanada28Result()
      },
      async queryCanada28Result() {
        try {
          let res = await this.$axios.post("https://apis.pcz28.com/api/canada28/getResultRecord", this.listQuery)
          this.jndtableData = res.data
          this.jndqueryOpenNum = {
            openNum: "",
            result: ["--", '--', '--']
          }
          if (this.jndtableData.length > 0) {
            if (this.showResultModel == 1) {
              this.showResultModel = 0
              this.$nextTick(() => {
                this.showResultModel = 1
                this.jndqueryOpenNum = this.jndtableData[1]
              })
            } else {
              this.jndqueryOpenNum = this.jndtableData[1]
            }
          }
          this.calcResult(this.jndtableData);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      },
  
      jndcalcNextTime() {
        if (this.jndlastNumInfo.stopBetTime == 0) return
        let time2 = this.jndlastNumInfo.stopBetTime - (new Date()).valueOf() / 1000
        let time3 = this.jndlastNumInfo.openTime - (new Date()).valueOf() / 1000
        time2 = parseInt(time2)
        if (time3 <= 0) {this.getCanada28LastNumInfo()}
        if (time2 <= 0) {
          this.$set(this.jndnextNumTime, 0, "--")
          this.$set(this.jndnextNumTime, 1, "--")
          this.jndshowWait = true
          return
        }
        this.jndshowWait = false
        let mTime = parseInt(time2 / 60)
        let sTime = time2 % 60
        if (mTime < 10) mTime = '0' + mTime;
        if (sTime < 10) sTime = '0' + sTime
        this.$set(this.jndnextNumTime, 0, mTime)
        this.$set(this.jndnextNumTime, 1, sTime)
      },
      
      twcalcNextTime() {
        if (this.twlastNumInfo.stopBetTime == 0) return
        let time2 = this.twlastNumInfo.stopBetTime - (new Date()).valueOf() / 1000
        let time3 = this.twlastNumInfo.openTime - (new Date()).valueOf() / 1000
        time2 = parseInt(time2)
        if (time3 <= 0) {this.getTaiwan28LastNumInfo()}
        if (time2 <= 0) {
          this.$set(this.twnextNumTime, 0, "--")
          this.$set(this.twnextNumTime, 1, "--")
          this.twshowWait = true
          return
        }
        this.twshowWait = false
        let mTime = parseInt(time2 / 60)
        let sTime = time2 % 60
        if (mTime < 10) mTime = '0' + mTime;
        if (sTime < 10) sTime = '0' + sTime
        this.$set(this.twnextNumTime, 0, mTime)
        this.$set(this.twnextNumTime, 1, sTime)
      },
  
      bjcalcNextTime() {
        if (this.bjlastNumInfo.stopBetTime == 0) return
        let time2 = this.bjlastNumInfo.stopBetTime - (new Date()).valueOf() / 1000
        let time3 = this.bjlastNumInfo.openTime - (new Date()).valueOf() / 1000
        time2 = parseInt(time2)
        if (time3 <= 0) {this.getBeijing28LastNumInfo()}
        if (time2 <= 0) {
          this.$set(this.bjnextNumTime, 0, "--")
          this.$set(this.bjnextNumTime, 1, "--")
          this.bjshowWait = true
          return
        }
        this.bjshowWait = false
        let mTime = parseInt(time2 / 60)
        let sTime = time2 % 60
        if (mTime < 10) mTime = '0' + mTime;
        if (sTime < 10) sTime = '0' + sTime
        this.$set(this.bjnextNumTime, 0, mTime)
        this.$set(this.bjnextNumTime, 1, sTime)
      },
  
      xgcalcNextTime() {
        if (this.xglastNumInfo.stopBetTime == 0) return
        let time2 = this.xglastNumInfo.stopBetTime - (new Date()).valueOf() / 1000
        let time3 = this.xglastNumInfo.openTime - (new Date()).valueOf() / 1000
        time2 = parseInt(time2)
        if (time3 <= 0) {this.getHongKong28LastNumInfo()}
        if (time2 <= 0) {
          this.$set(this.xgnextNumTime, 0, "--")
          this.$set(this.xgnextNumTime, 1, "--")
          this.xgshowWait = true
          return
        }
        this.xgshowWait = false
        let mTime = parseInt(time2 / 60)
        let sTime = time2 % 60
        if (mTime < 10) mTime = '0' + mTime;
        if (sTime < 10) sTime = '0' + sTime
        this.$set(this.xgnextNumTime, 0, mTime)
        this.$set(this.xgnextNumTime, 1, sTime)
      },
  
      getSum(queryopennum) {return queryopennum.result[0] + queryopennum.result[1] + queryopennum.result[2]},
  
      isBigNum(sum) {
        if (sum >= 14) return true
        return false
      },
      isOddNumber(sum) {
        if (sum == 0 || (sum % 2 == 0)) return false
        return true
      },
      getColor(getsum){
          let a= getsum.toString().padStart(2, '0');
          const array1 = ['00', '06', '05', '11', '16', '17', '21', '22'];
          const array2 = ['01', '02', '07', '08', '12', '13', '18', '19', '23', '24'];
          const array3 = ['03', '04', '09', '10', '14', '15', '20', '25', '26', '27'];
          if (array1.includes(a)) {
              return 1;
          } else if (array2.includes(a)) {
              return 2;
          } else if (array3.includes(a)) {
              return 3;
          } else {
              return 4;
          }
      },
      describeTools(qon){
        let arr =qon.result;
        const uniqueValues = Array.from(new Set(arr));
          switch (uniqueValues.length) {
              case 0:
                  return '';
              case 1:
                  return '豹子';
              case 2:
                  return '对子';
              case 3:
                  return '杂三';
              default:{
                  const isSequential = arr.every((value, index) => index === 0 || value === arr[index - 1] + 1);
                  return isSequential ? '顺子' : '';
              }
          }
      },
      getdate(times) {
        var now = new Date(times * 1000),
          y = now.getFullYear(),
          m = now.getMonth() + 1,
          d = now.getDate();
        return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
      }
    }
  }
  </script>
  <style lang="scss" scoped>

  .bannerleft{
          cursor: pointer;
          display: flex;
          width: 1.2rem;
          img{
              height: 1.2rem;
          }
          /* h1{
              margin-left: 5px;
              line-height: 36px;
              font-weight: 500;
              font-size: 20px;
          } */
    }

  .tabtitle{
    height: 1.5rem;
    border-collapse: collapse;
    tr{
        td{
            cursor: pointer;
            color: #606266;
            text-align: center;
            width: 3.1rem;
            font-size: 0.22rem;
            border: 1px solid #DCDFE6;
        }
        td:hover{
            border: 1px solid #C6E2FF;
            color: #409EFF;
            background-color: #ECF5FF;
        }
        .active {
            background-color: #ECF5FF;
            color: #409EFF;
            border: 0.01rem solid #409EFF;
        }
    }
}
  .project-dropdown {
    height: 300px;
    overflow: auto;
  }
  
  .project-dropdown::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background-color: #F5F5F5;
  }
  
  .project-dropdown::-webkit-scrollbar-track {
    /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);*/
    border-radius: 10px;
    background-color: #F5F5F5;
  }

  .nlotIContent {
    display: flex;
    flex-wrap: wrap;
    font-family: DM Mono,ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;
    .outer{
        width: 100%;
        border: 0.5px solid #DCDFE6;
        margin-bottom: 0.18rem;
        padding: 0.3rem;
        .cent{
           .within{
              display: flex;
              img{
                width: 1.6rem;
                height: 1.6rem;
                cursor: pointer;
                transition: transform 0.3s ease-in-out;
              }
              .dont{
                width: 100%;
                    .top{
                        margin-left: 0.2rem;
                        line-height: 1rem;
                        height: 1rem;
                        font-size: 0.32rem;
                        i{
                            margin: 0.1rem;
                            font-size: 0.3rem;
                            font-style: normal;
                            color: #74B0FB;
                            font-weight: 400;
                        }
                        .lef:hover{
                            cursor: pointer;
                            color: #409EFF;
                        }
                        .rig{
                            margin-left: 0.1rem;
                            font-size: 0.22rem;
                            color: #9CA3AF
                        }
                    }
                    .bot{
                        display: flex;
                        justify-content: space-between;
                        .lef{
                            margin-left: 0.1rem;
                            margin-top: 0.2rem;
                            display: flex;
                            .cyanBlue{
                                color: #EF4444;
                                border: 1px solid #F0F0F5;
                                background-color: #ffffff;
                                width: 0.5rem;
                                height: 0.5rem;
                                line-height: 0.5rem;
                                border-radius: 50%;
                                font-weight: 400;
                            }
                            .ml5{
                                line-height: 0.5rem;
                            }
                            .skyBlue{
                                font-size: 0.35rem;
                                margin-left: 0.3rem;
                                width: 0.6rem;
                                height: 0.6rem;
                                color: black;
                                border: 1px solid black;
                                background-color: #ffffff;
                                border-radius: 50%;
                                font-weight: 500;
                                line-height: 0.6rem;
                            }
                            .skyBlue1{
                                color: #67C23A;
                                border: 1px solid #67C23A;
                            }
                            .skyBlue2{
                                color: #F56C6C;
                                border: 1px solid #F56C6C;
                            }
                            .skyBlue3{
                                color: #409EFF;
                                border: 1px solid #409EFF;
                            }
                        }
                        .rig{
                            margin-top: 0.2rem;
                            b{
                                font-size: 0.6rem;
                                color: #ea580c;
                                font-weight: 400;
                                margin: 0.1rem;
                            }
                        }
                    }
              }
           }
           table{
            margin-top: 0.2rem;
            line-height: 0.5rem;
            .top{
                background-color: #FAFAFC;
            }
            border-collapse: collapse;
            font-size: 0.27rem;
            height: 0.5rem;
            width: 100%;
            text-align: center;
            tr{
                td{
                    border: 1px solid #EFEFF5;
                }
            }
            .le{
                height: 100%;
                display: flex;
                justify-content: space-around;
                padding: 0 2rem;
            }
           }
           .botto{
            border: 1px solid green;
            height: 1rem;
           }
        }
    }
}

  
  </style>
  